var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRun = function SvgRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "run_svg__a",
    width: 16,
    height: 17,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#run_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M8.607 15.166v-3.301l-1.304-1.242-.485 2.16a.75.75 0 0 1-.33.467.75.75 0 0 1-.561.105l-3.276-.662a.7.7 0 0 1-.471-.31.74.74 0 0 1-.106-.558.72.72 0 0 1 .311-.48.68.68 0 0 1 .56-.101l2.474.521 1.035-5.24-1.097.423v1.56q0 .307-.21.517a.7.7 0 0 1-.516.21.7.7 0 0 1-.519-.212.7.7 0 0 1-.211-.52V6.499a.7.7 0 0 1 .126-.414.8.8 0 0 1 .337-.277l2.246-.955q.595-.25.874-.33.279-.078.516-.078.37 0 .678.195.308.196.503.507l.675 1.067q.338.547.88.95.543.402 1.264.54a.94.94 0 0 1 .517.278q.21.22.21.527t-.212.51a.58.58 0 0 1-.506.162 5.1 5.1 0 0 1-1.658-.542 4.8 4.8 0 0 1-1.315-1.01l-.368 1.86 1.16 1.097q.115.113.174.255a.8.8 0 0 1 .058.296v4.03q0 .307-.21.517a.7.7 0 0 1-.516.21.7.7 0 0 1-.517-.21.7.7 0 0 1-.21-.517m.401-11.06q-.578 0-.987-.409a1.35 1.35 0 0 1-.41-.987q0-.578.41-.986a1.35 1.35 0 0 1 .987-.408q.578 0 .986.408.407.408.407.986t-.407.987q-.407.41-.986.41"
  }))));
};
export default SvgRun;